import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingCart, LogOut, User, Contact2Icon, Users, Calculator, BarChart, Megaphone, Bot, Building, ShieldAlert } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const navItems = [
  { name: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
  { name: 'Manufacturers', icon: Users, path: '/manufacturers' },
  { name: 'Products', icon: Package, path: '/products' },
  { name: 'Orders', icon: ShoppingCart, path: '/orders' },
  { name: 'Grievances (IGM)', icon: ShieldAlert, path: '/issues' },
  { name: 'Price Calculator', icon: Calculator, path: '/calculator' },
  { name: 'Reports', icon: BarChart, path: '/reports' },
  // { name: 'Campaigns', icon: Megaphone, path: '/campaigns' },
  { name: 'AI Assistant', icon: Bot, path: '/ai-assistant' },
  { name: 'Account', icon: User, path: '/account' },
];

const Sidebar = () => {
  const location = useLocation();
  const { brandLogo, brandName, isBranded, role } = useTheme();

  const isActive = (path: string) => location.pathname === path;

  // Items only visible to ORGANISATION accounts
  const ORG_ONLY_ITEMS = ['Manufacturers', 'Price Calculator', 'Reports', 'AI Assistant'];

  const visibleNavItems = navItems.filter(item => {
      if (role === 'SELLER' && ORG_ONLY_ITEMS.includes(item.name)) return false;
      return true;
  });


  return (
    <div className="w-64 h-screen bg-white border-r shadow-sm fixed top-0 left-0 flex flex-col">
      <div className="pt-4 pb-4 px-4 border-b flex flex-col items-center justify-center">
        {isBranded ? (
             brandLogo ? (
               <img src={brandLogo} alt="Logo" className="w-20 h-20 object-contain rounded-full mb-2 shadow-sm border" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
             ) : (
               <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-2 text-green-600">
                 <Building size={32} />
               </div>
             )
        ) : role === 'ORGANISATION' ? (
             <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-2 text-green-600">
               <Building size={32} />
             </div>
        ) : (
             <img src={require('../assets/logo.png')} alt="Logo" className="w-20 object-contain mb-2" />
        )}
        <h2 className="font-semibold text-gray-700 text-center">
          {isBranded ? brandName : (role === 'ORGANISATION' ? 'Enterprise Portal' : brandName)}
        </h2>
        <span className="text-xs text-gray-400 uppercase tracking-wider">{role}</span>
      </div>
      <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
        {visibleNavItems.map(({ name, icon: Icon, path }) => (
          <Link
            key={name}
            to={path}
            className={`flex items-center gap-3 px-4 py-2 rounded-lg transition ${
              isActive(path)
                ? 'bg-green-100 text-green-700 font-semibold'
                : 'text-gray-600 hover:bg-gray-100 hover:text-green-600'
            }`}
          >
            <Icon size={20} />
            {name}
          </Link>
        ))}
      </nav>
      <div className="p-4 border-t">
        <button
          onClick={() => {
            localStorage.removeItem('authToken');
            window.location.href = '/login';
          }}
          className="flex items-center gap-3 px-4 py-2 w-full text-left text-gray-600 hover:text-red-600 hover:bg-red-100 rounded-lg transition"
        >
          <LogOut size={20} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
